<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>History Data Anggota</h5>
            </template>
            <div class="form-content-wrapper mb-4">
                <b-form-group>
                    <b-form-select v-model="input.historyNasabah" name="historyNasabah" :options="historyNasabahOption" value-field="id" text-field="name">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>History </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <p v-if="historyNasabahOption.length == 0">Tidak ada perubahan untuk data nasabah ini</p>
            <div v-if="input.historyNasabah != null && anggota != null">
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA KTP</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama Anggota</b-col>
                        <b-col>{{ anggota.nama }}</b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="anggota.jenisIdentitas != null">
                        <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                        <b-col>{{ anggota.jenisIdentitas.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nomor Identitas</b-col>
                        <b-col>{{ anggota.noIdentitas }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Kelamin</b-col>
                    <b-col v-if="anggota.detail.jenisKelamin != null">
                       <div v-if="anggota.detail.jenisKelamin == 'L'">Laki - laki</div>
                       <div v-if="anggota.detail.jenisKelamin == 'P'">Perempuan</div>
                    </b-col>
                    <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Perkawinan</b-col>
                        <b-col v-if="anggota.detail.statusPerkawinan != null">
                        <div v-if="anggota.detail.statusPerkawinan == 'BK'">Belum Kawin</div>
                        <div v-if="anggota.detail.statusPerkawinan == 'KA'">Kawin</div>
                        <div v-if="anggota.detail.statusPerkawinan == 'CH'">Cerai Hidup</div>
                        <div v-if="anggota.detail.statusPerkawinan == 'CM'">Cerai Mati</div>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kewarganegaraan</b-col>
                        <b-col v-if="anggota.detail.kewarganegaraan != null">{{ anggota.detail.kewarganegaraan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kota Lahir</b-col>
                        <b-col>{{ anggota.detail.kotaLahir.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tanggal Lahir</b-col>
                        <b-col>
                            <div>{{$helper.changeDateFormat(anggota.detail.tanggalLahir)}}</div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kota</b-col>
                        <b-col>{{ anggota.detail.kotaKtp.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                        <b-col>{{ anggota.detail.kecamatanKtp.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                        <b-col>{{ anggota.detail.kelurahanDesaKtp.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                        <b-col>{{ anggota.detail.rtKtp }}/{{ anggota.detail.rwKtp }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat KTP</b-col>
                        <b-col>{{ anggota.detail.alamatKtp }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat Tempat Kerja</b-col>
                        <b-col v-if="anggota.detail.alamatTempatKerja != null">{{ anggota.detail.alamatTempatKerja }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Telepon Tempat Kerja</b-col>
                        <b-col v-if="anggota.detail.teleponTempatKerja != null">{{ anggota.detail.teleponTempatKerja }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Pekerjaan</b-col>
                        <b-col v-if="anggota.detail.pekerjaanBaru != null">{{ anggota.detail.pekerjaanBaru.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Pekerjaan</b-col>
                        <b-col>{{ anggota.detail.pekerjaan }}</b-col>
                    </b-row>
                    <!-- <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Telp Rumah</b-col>
                        <b-col>{{ anggota.detail.teleponRumahSekarang }}</b-col>
                    </b-row> -->
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                        <b-col>{{ anggota.detail.noHandphoneSekarang }}</b-col>
                    </b-row>
                    <!-- <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Telp Kantor</b-col>
                        <b-col>{{ anggota.detail.teleponKantorSekarang }}</b-col>
                    </b-row> -->
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kota</b-col>
                        <b-col>{{ anggota.detail.kotaSekarang.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                        <b-col>{{ anggota.detail.kecamatanSekarang.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                        <b-col>{{ anggota.detail.kelurahanDesaSekarang.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                        <b-col>{{ anggota.detail.rtSekarang }}/{{ anggota.detail.rwSekarang }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat Sekarang</b-col>
                        <b-col>{{ anggota.detail.alamatSekarang }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nomor / Nama Gang</b-col>
                        <b-col v-if="anggota.detail.nomorGang != null">{{ anggota.detail.nomorGang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nomor Rumah</b-col>
                        <b-col v-if="anggota.detail.nomorRumah != null">{{ anggota.detail.nomorRumah }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA KELUARGA</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama Suami / Istri</b-col>
                        <b-col v-if="anggota.detail.namaSuamiAtauIstri != '' && anggota.detail.namaSuamiAtauIstri != null">{{ anggota.detail.namaSuamiAtauIstri }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone Suami / Istri</b-col>
                        <b-col v-if="anggota.detail.noHandphoneSuamiIstri != '' && anggota.detail.noHandphoneSuamiIstri != null">{{ anggota.detail.noHandphoneSuamiIstri }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Ayah</b-col>
                        <b-col v-if="anggota.detail.namaAyah != '' && anggota.detail.namaAyah != null">{{ anggota.detail.namaAyah }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone Ayah</b-col>
                        <b-col v-if="anggota.detail.noHandphoneAyah != '' && anggota.detail.noHandphoneAyah != null">{{ anggota.detail.noHandphoneAyah }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Ibu</b-col>
                        <b-col v-if="anggota.detail.namaIbu != '' && anggota.detail.namaIbu != null">{{ anggota.detail.namaIbu }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone Ibu</b-col>
                        <b-col v-if="anggota.detail.noHandphoneIbu != '' && anggota.detail.noHandphoneIbu != null">{{ anggota.detail.noHandphoneIbu }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">PIHAK LAIN (Keluarga yang Tidak Serumah)</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col v-if="anggota.detail.namaPihakLain != '' && anggota.detail.namaPihakLain != null">{{ anggota.detail.namaPihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Hubungan</b-col>
                        <b-col v-if="anggota.detail.hubunganPihakLain != '' && anggota.detail.hubunganPihakLain != null">{{ anggota.detail.hubunganPihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <!-- <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Telp Rumah</b-col>
                        <b-col v-if="anggota.detail.teleponRumahPihakLain != '' && anggota.detail.teleponRumahPihakLain != null">{{ anggota.detail.teleponRumahPihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row> -->
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                        <b-col v-if="anggota.detail.noHandphonePihakLain != '' && anggota.detail.noHandphonePihakLain != null">{{ anggota.detail.noHandphonePihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <!-- <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Telp Kantor</b-col>
                        <b-col v-if="anggota.detail.teleponKantorPihakLain != '' && anggota.detail.teleponKantorPihakLain != null">{{ anggota.detail.teleponKantorPihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row> -->
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kota</b-col>
                        <b-col v-if="anggota.detail.kotaPihakLain.name != null">{{ anggota.detail.kotaPihakLain.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kecamatan</b-col>
                        <b-col v-if="anggota.detail.kecamatanPihakLain.name != null">{{ anggota.detail.kecamatanPihakLain.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelurahan</b-col>
                        <b-col v-if="anggota.detail.kelurahanDesaPihakLain.name != null">{{ anggota.detail.kelurahanDesaPihakLain.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">RT/RW</b-col>
                        <b-col v-if="anggota.detail.rtPihakLain != '' && anggota.detail.rwPihakLain != '' && anggota.detail.rtPihakLain != null && anggota.detail.rwPihakLain != null">
                            {{ anggota.detail.rtPihakLain }}/{{ anggota.detail.rwPihakLain }}
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat Sekarang</b-col>
                        <b-col v-if="anggota.detail.alamatPihakLain != '' && anggota.detail.alamatPihakLain != null">{{ anggota.detail.alamatPihakLain }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA FOTO</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto Identitas</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoKtp" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoKtp" alt="Foto Identitas">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoFormSurvey)">
                        <b-col cols="4" class="detail-data-label">Form Survey</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoFormSurvey" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoFormSurvey" alt="Form Survey">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoFormDataBpkb)">
                        <b-col cols="4" class="detail-data-label">Foto Form Data BPKB</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoFormDataBpkb" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoFormDataBpkb" alt="Foto Form Data BPKB">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung1)">
                        <b-col cols="4" class="detail-data-label">Foto Pendukung 1</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoPendukung1" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoPendukung1" alt="Foto Pendukung 1">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung2)">
                        <b-col cols="4" class="detail-data-label">Foto Pendukung 2</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoPendukung2" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoPendukung2" alt="Foto Pendukung 2">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="!$helper.isNullOrEmpty(anggota.detail.fotoPendukung3)">
                        <b-col cols="4" class="detail-data-label">Foto Pendukung 3</b-col>
                        <b-col>
                            <a v-bind:href="anggota.detail.fotoPendukung3" target="_blank">
                                <img width="150px" :src="anggota.detail.fotoPendukung3" alt="Foto Pendukung 3">
                            </a>
                            <span class="file-name mt-2"></span>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'history-data-anggota',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            input:{
                historyNasabah: null
            },
            historyNasabahOption : [],
            anggota: null,
        }
    }, 
    watch: {

        'input.historyNasabah': function(newVal) {

            if(newVal != null){
                this.$axios.get(`nasabah/detail-revisi/${newVal}`).then(response => {
                    this.anggota = response.data

                    if (this.anggota.detail.fotoPendukung1 == null) this.anggota.detail.fotoPendukung1 = "no_img.null"
                    if (this.anggota.detail.fotoPendukung2 == null) this.anggota.detail.fotoPendukung2 = "no_img.null"
                    if (this.anggota.detail.fotoPendukung3 == null) this.anggota.detail.fotoPendukung3 = "no_img.null"
                })
            }

        },
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            
            this.id = this.$route.params.id

            let getHistoryOption = this.$axios.get(`nasabah/daftar-revisi/${this.id}`).then(response => {
                this.historyNasabahOption = response.data
            })

            Promise.all([getHistoryOption]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
    },

    created(){
        this.init()
    }
}
</script>